'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TYPES = exports.ADVANCED = exports.PREMIUM = exports.FREE = undefined;

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getTypeFromServerConfig = getTypeFromServerConfig;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../languageHandler');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AutoDiscoveryUtils = require('../../../utils/AutoDiscoveryUtils');

var _TypeUtils = require('../../../utils/TypeUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULAR_URL = 'https://modular.im/?utm_source=riot-web&utm_medium=web&utm_campaign=riot-web-authentication'; /*
                                                                                                                 Copyright 2019 New Vector Ltd
                                                                                                                 
                                                                                                                 Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                 you may not use this file except in compliance with the License.
                                                                                                                 You may obtain a copy of the License at
                                                                                                                 
                                                                                                                     http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                 
                                                                                                                 Unless required by applicable law or agreed to in writing, software
                                                                                                                 distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                 See the License for the specific language governing permissions and
                                                                                                                 limitations under the License.
                                                                                                                 */

var FREE = exports.FREE = 'Free';
var PREMIUM = exports.PREMIUM = 'Premium';
var ADVANCED = exports.ADVANCED = 'Advanced';

var TYPES = exports.TYPES = {
    FREE: {
        id: FREE,
        label: function label() {
            return (0, _languageHandler._t)('Free');
        },
        logo: function logo() {
            return _react2.default.createElement('img', { src: require('../../../../res/img/matrix-org-bw-logo.svg') });
        },
        description: function description() {
            return (0, _languageHandler._t)('Join millions for free on the largest public server');
        },
        serverConfig: (0, _TypeUtils.makeType)(_AutoDiscoveryUtils.ValidatedServerConfig, {
            hsUrl: "https://matrix-client.matrix.org",
            hsName: "matrix.org",
            hsNameIsDifferent: false,
            isUrl: "https://vector.im"
        })
    },
    PREMIUM: {
        id: PREMIUM,
        label: function label() {
            return (0, _languageHandler._t)('Premium');
        },
        logo: function logo() {
            return _react2.default.createElement('img', { src: require('../../../../res/img/modular-bw-logo.svg') });
        },
        description: function description() {
            return (0, _languageHandler._t)('Premium hosting for organisations <a>Learn more</a>', {}, {
                a: function a(sub) {
                    return _react2.default.createElement(
                        'a',
                        { href: MODULAR_URL, target: '_blank', rel: 'noopener' },
                        sub
                    );
                }
            });
        },
        identityServerUrl: "https://vector.im"
    },
    ADVANCED: {
        id: ADVANCED,
        label: function label() {
            return (0, _languageHandler._t)('Advanced');
        },
        logo: function logo() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('img', { src: require('../../../../res/img/feather-customised/globe.svg') }),
                (0, _languageHandler._t)('Other')
            );
        },
        description: function description() {
            return (0, _languageHandler._t)('Find other public servers or use a custom server');
        }
    }
};

function getTypeFromServerConfig(config) {
    var hsUrl = config.hsUrl;

    if (!hsUrl) {
        return null;
    } else if (hsUrl === TYPES.FREE.serverConfig.hsUrl) {
        return FREE;
    } else if (new URL(hsUrl).hostname.endsWith('.modular.im')) {
        // This is an unlikely case to reach, as Modular defaults to hiding the
        // server type selector.
        return PREMIUM;
    } else {
        return ADVANCED;
    }
}

var ServerTypeSelector = function (_React$PureComponent) {
    (0, _inherits3.default)(ServerTypeSelector, _React$PureComponent);

    function ServerTypeSelector(props) {
        (0, _classCallCheck3.default)(this, ServerTypeSelector);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ServerTypeSelector.__proto__ || (0, _getPrototypeOf2.default)(ServerTypeSelector)).call(this, props));

        _this.onClick = function (e) {
            e.stopPropagation();
            var type = e.currentTarget.dataset.id;
            _this.updateSelectedType(type);
        };

        var selected = props.selected;


        _this.state = {
            selected: selected
        };
        return _this;
    }

    (0, _createClass3.default)(ServerTypeSelector, [{
        key: 'updateSelectedType',
        value: function updateSelectedType(type) {
            if (this.state.selected === type) {
                return;
            }
            this.setState({
                selected: type
            });
            if (this.props.onChange) {
                this.props.onChange(type);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');

            var serverTypes = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)((0, _values2.default)(TYPES)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var type = _step.value;
                    var id = type.id,
                        label = type.label,
                        logo = type.logo,
                        description = type.description;

                    var classes = (0, _classnames2.default)("mx_ServerTypeSelector_type", 'mx_ServerTypeSelector_type_' + id, {
                        "mx_ServerTypeSelector_type_selected": id === this.state.selected
                    });

                    serverTypes.push(_react2.default.createElement(
                        'div',
                        { className: classes, key: id },
                        _react2.default.createElement(
                            'div',
                            { className: 'mx_ServerTypeSelector_label' },
                            label()
                        ),
                        _react2.default.createElement(
                            AccessibleButton,
                            { onClick: this.onClick, 'data-id': id },
                            _react2.default.createElement(
                                'div',
                                { className: 'mx_ServerTypeSelector_logo' },
                                logo()
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'mx_ServerTypeSelector_description' },
                                description()
                            )
                        )
                    ));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return _react2.default.createElement(
                'div',
                { className: 'mx_ServerTypeSelector' },
                serverTypes
            );
        }
    }]);
    return ServerTypeSelector;
}(_react2.default.PureComponent);

ServerTypeSelector.propTypes = {
    // The default selected type.
    selected: _propTypes2.default.string,
    // Handler called when the selected type changes.
    onChange: _propTypes2.default.func.isRequired
};
exports.default = ServerTypeSelector;
//# sourceMappingURL=ServerTypeSelector.js.map